import { useState } from 'react';
import { 
  AppShell, 
  Burger, 
  Group, 
  NavLink, 
  Title, 
  ThemeIcon, 
  rem, 
  ScrollArea, 
  Text 
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  IconHome2,
  IconUsers,
  IconFolderOpen,
  IconCalendarOff, 
  IconChartBar,
  IconSettings,
} from '@tabler/icons-react';
import TopNavbar from '../components/TopNavbar';


const navLinks = [
  { label: 'Dashboard', icon: IconHome2, path: '/hr/dashboard', color: 'blue' },
  { label: 'Personeller', icon: IconUsers, path: '/hr/employees', color: 'cyan' },
  { label: 'Evrak Yönetimi', icon: IconFolderOpen, path: '/hr/documents', color: 'orange' },
  { label: 'İzin Takibi', icon: IconCalendarOff, path: '/hr/leaves', color: 'teal' },
  { label: 'Raporlar', icon: IconChartBar, path: '/hr/reports', color: 'grape' },
  { label: 'Tanımlar', icon: IconSettings, path: '/hr/definitions', color: 'gray' },
];

export default function HrLayout() {
  const [opened, { toggle, close }] = useDisclosure();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <AppShell
      header={{ height: 65 }} 
      navbar={{
        width: 240, 
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
      bg="gray.0"
    >
              <AppShell.Header>
                {/* Sidebar olduğu için toggle ve opened proplarını gönderiyoruz (Mobilde hamburger menü çıkması için) */}
                <TopNavbar 
                  opened={opened} 
                  toggle={toggle} 
                  showBackButton={true} 
                  title="Grup" 
                  highlight="Filo" 
                />
              </AppShell.Header>

      <AppShell.Navbar p="md">
        <Text c="dimmed" size="xs" fw={700} mb="sm" tt="uppercase" ls={1}>
          İnsan Kaynakları
        </Text>
        <AppShell.Section grow component={ScrollArea}>
          {navLinks.map((item) => {
            const isActive = location.pathname.includes(item.path);
            return (
              <NavLink
                key={item.label}
                label={item.label}
                leftSection={
                  <ThemeIcon 
                    variant={isActive ? 'filled' : 'light'} 
                    color={item.color} 
                    size={32} 
                    radius="md"
                  >
                    <item.icon style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
                  </ThemeIcon>
                }
                active={isActive}
                onClick={() => {
                  navigate(item.path);
                  if (opened) close(); 
                }}
                variant="filled"
                color="blue"
                style={{ borderRadius: '8px', marginBottom: '4px', fontWeight: isActive ? 600 : 500 }}
              />
            );
          })}
        </AppShell.Section>
      </AppShell.Navbar>

      <AppShell.Main>
        {/* DİKKAT: Container silindi, saf genişleyen div eklendi */}
        <div style={{ width: '100%', height: '100%', padding: '0' }}>
          <Outlet /> 
        </div>
      </AppShell.Main>
    </AppShell>
  );
}